import BaseRegulation from './base_regulation';

class DefaultRegulation extends BaseRegulation {

	static CLASS = 'DefaultRegulation';

	init(params) {
		super.init(params);
	}

}

export default DefaultRegulation;